export interface TreeViewItem {
  id?: string;
  text: string;
  description?: string | null;
  icon: string;
  archived?: boolean;
  archivedText?: string;
  image?: string | null;
  children?: TreeViewItem[];
  parent?: TreeViewItem;
  original?: any;
  searchTerm?: string;
  action: TreeViewAction;
  metadata?: any;
}

export interface TreeViewAction {
  type: ActionTypeEnum;
  checked?: boolean;
  disabled?: boolean;
  buttons?: ActionButton[];
  action?(): Promise<any>;
}

export enum ActionTypeEnum {
  checkbox = 'checkbox',
  menu = 'menu',
  none = 'none'
}

export interface ActionButton {
  text: string;
  icon: string;
  color: string;
  disabled?: boolean;
  action(): Promise<any>;
}
